export interface AppColors {
  primary_color: string;
  secondary_color: string;
  header_bg_color: string;
  header_text_color: string;
  menu_bg_color: string;
  menu_text_color: string;
  footer_bg_color: string;
  footer_text_color: string;
  page_bg_color: string;
  card_bg_color: string;
  text_primary_color: string;
  text_secondary_color: string;
  border_color: string;
  input_bg_color: string;
  input_border_color: string;
  hover_bg_color: string;
  active_item_bg: string;
  active_item_text: string;
}

export interface ReportColors {
  header_color: string;
  header_text_color: string;
  body_background_color: string;
  body_text_color: string;
  table_header_color: string;
  table_header_label_color: string;
  section_heading_color: string;
  controller_header_color: string;
  info_label_color: string;
  summary_bg_color: string;
  summary_text_color: string;
  summary_highlight_color: string;
  border_color: string;
  ok_status_color: string;
  issue_status_color: string;
  issue_row_bg_color: string;
}

export interface AppTheme {
  id: string;
  name: string;
  slug: string;
  is_builtin: boolean;
  is_active: boolean;
  app_colors: AppColors;
  report_colors: ReportColors;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export const DEFAULT_APP_COLORS: AppColors = {
  primary_color: '#2563eb',
  secondary_color: '#1e40af',
  header_bg_color: '#ffffff',
  header_text_color: '#1f2937',
  menu_bg_color: '#ffffff',
  menu_text_color: '#374151',
  footer_bg_color: '#ffffff',
  footer_text_color: '#6b7280',
  page_bg_color: '#f9fafb',
  card_bg_color: '#ffffff',
  text_primary_color: '#111827',
  text_secondary_color: '#6b7280',
  border_color: '#e5e7eb',
  input_bg_color: '#ffffff',
  input_border_color: '#d1d5db',
  hover_bg_color: '#f3f4f6',
  active_item_bg: '#dbeafe',
  active_item_text: '#2563eb',
};

export const APP_COLOR_FIELDS: Array<{
  field: keyof AppColors;
  label: string;
  group: string;
}> = [
  { field: 'primary_color', label: 'Primary', group: 'Brand' },
  { field: 'secondary_color', label: 'Secondary', group: 'Brand' },
  { field: 'header_bg_color', label: 'Header Background', group: 'Layout' },
  { field: 'header_text_color', label: 'Header Text', group: 'Layout' },
  { field: 'menu_bg_color', label: 'Menu Background', group: 'Layout' },
  { field: 'menu_text_color', label: 'Menu Text', group: 'Layout' },
  { field: 'footer_bg_color', label: 'Footer Background', group: 'Layout' },
  { field: 'footer_text_color', label: 'Footer Text', group: 'Layout' },
  { field: 'page_bg_color', label: 'Page Background', group: 'Content' },
  { field: 'card_bg_color', label: 'Card Background', group: 'Content' },
  { field: 'text_primary_color', label: 'Primary Text', group: 'Content' },
  { field: 'text_secondary_color', label: 'Secondary Text', group: 'Content' },
  { field: 'border_color', label: 'Borders', group: 'Content' },
  { field: 'input_bg_color', label: 'Input Background', group: 'Controls' },
  { field: 'input_border_color', label: 'Input Border', group: 'Controls' },
  { field: 'hover_bg_color', label: 'Hover Background', group: 'Controls' },
  { field: 'active_item_bg', label: 'Active Item Background', group: 'Controls' },
  { field: 'active_item_text', label: 'Active Item Text', group: 'Controls' },
];

export const REPORT_COLOR_FIELDS: Array<{
  field: keyof ReportColors;
  label: string;
  group: string;
}> = [
  { field: 'header_color', label: 'Header Background', group: 'Layout' },
  { field: 'header_text_color', label: 'Header Text', group: 'Layout' },
  { field: 'body_background_color', label: 'Body Background', group: 'Layout' },
  { field: 'body_text_color', label: 'Body Text', group: 'Layout' },
  { field: 'section_heading_color', label: 'Section Headings', group: 'Layout' },
  { field: 'info_label_color', label: 'Info Labels', group: 'Layout' },
  { field: 'border_color', label: 'Borders', group: 'Layout' },
  { field: 'controller_header_color', label: 'Controller Header', group: 'Tables' },
  { field: 'table_header_color', label: 'Table Header Background', group: 'Tables' },
  { field: 'table_header_label_color', label: 'Table Header Text', group: 'Tables' },
  { field: 'ok_status_color', label: 'OK Status', group: 'Status' },
  { field: 'issue_status_color', label: 'Issue Status', group: 'Status' },
  { field: 'issue_row_bg_color', label: 'Issue Row Highlight', group: 'Status' },
  { field: 'summary_bg_color', label: 'Summary Background', group: 'Summary' },
  { field: 'summary_text_color', label: 'Summary Text', group: 'Summary' },
  { field: 'summary_highlight_color', label: 'Summary Highlight', group: 'Summary' },
];
